module.exports = __webpack_public_path__ + "img/254-nato.7864b37c.svg";